import Vue from 'vue'
import App from './App.vue'
import router from '@/router/router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './util/rem'

Vue.use(ElementUI)
Vue.use(router)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
